import { useEffect, useRef } from 'react';

const OrderCustomerFields = ({
  customerName,
  phone,
  customerAddress,
  onCustomerNameChange,
  onPhoneChange,
  onCustomerAddressChange,
  accentFocus = 'focus:ring-green-500 focus:border-green-500',
  compact = false,
  variant,
  phoneRequired = true,
}) => {
  const nameRef = useRef(null);
  const resolvedVariant = variant || (compact ? 'compact' : 'default');
  const phoneLabel = phoneRequired ? 'Phone *' : 'Phone';

  useEffect(() => {
    nameRef.current?.focus();
  }, []);

  const handlePhoneBlur = () => {
    const normalized = phone.replace(/\D/g, '').slice(0, 10);
    if (normalized !== phone) {
      onPhoneChange(normalized);
    }
  };

  const inputClass = `toolbar-input max-w-full ${accentFocus}`;

  const nameField = (labelClass = 'text-xs') => (
    <div className={resolvedVariant === 'header' ? '' : resolvedVariant === 'compact' ? 'col-span-2 sm:col-span-1' : ''}>
      <label className={`block ${labelClass} font-medium text-gray-600 mb-0.5`}>Name *</label>
      <input
        ref={nameRef}
        type="text"
        value={customerName}
        onChange={(e) => onCustomerNameChange(e.target.value)}
        className={inputClass}
        placeholder="Customer name"
      />
    </div>
  );

  const phoneField = (labelClass = 'text-xs') => (
    <div>
      <label className={`block ${labelClass} font-medium text-gray-600 mb-0.5`}>{phoneLabel}</label>
      <input
        type="tel"
        value={phone}
        onChange={(e) => onPhoneChange(e.target.value)}
        onBlur={handlePhoneBlur}
        className={inputClass}
        placeholder={phoneRequired ? '10-digit mobile' : '10-digit mobile (optional)'}
      />
    </div>
  );

  const addressField = (labelClass = 'text-xs') => (
    <div>
      <label className={`block ${labelClass} font-medium text-gray-600 mb-0.5`}>Address</label>
      <input
        type="text"
        value={customerAddress}
        onChange={(e) => onCustomerAddressChange(e.target.value)}
        className={inputClass}
        placeholder="City, area, landmark (optional)"
      />
    </div>
  );

  if (resolvedVariant === 'header') {
    return (
      <div className="grid grid-cols-2 gap-1.5 sm:grid-cols-3 sm:gap-2">
        <div className="col-span-2 sm:col-span-1">{nameField('text-[10px]')}</div>
        {phoneField('text-[10px]')}
        {addressField('text-[10px]')}
      </div>
    );
  }

  if (resolvedVariant === 'compact') {
    return (
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 sm:gap-3">
        {nameField()}
        {phoneField()}
        {addressField()}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Customer Name *</label>
        <input
          ref={nameRef}
          type="text"
          value={customerName}
          onChange={(e) => onCustomerNameChange(e.target.value)}
          className={inputClass}
          placeholder="Customer name"
          required
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">{phoneLabel}</label>
        <input
          type="tel"
          value={phone}
          onChange={(e) => onPhoneChange(e.target.value)}
          onBlur={handlePhoneBlur}
          className={inputClass}
          placeholder={phoneRequired ? '10-digit mobile' : '10-digit mobile (optional)'}
          pattern={phoneRequired ? '[6-9][0-9]{9}' : undefined}
          required={phoneRequired}
        />
      </div>
      <div>
        <label className="block text-xs font-medium text-gray-600 mb-1">Address</label>
        <input
          type="text"
          value={customerAddress}
          onChange={(e) => onCustomerAddressChange(e.target.value)}
          className={inputClass}
          placeholder="City, area, landmark (optional)"
        />
      </div>
    </div>
  );
};

export default OrderCustomerFields;
